import { observer } from 'mobx-react-lite';
import { ChangeEvent } from 'react';
import { FormInput } from 'src/shared/components/form-components';

import { TextField } from '../../../../shared/entities/control-entities';

type Props = {
  className?: string;
  label?: string;
  item: TextField;
  isDisabled: boolean;
  onBlur?: VoidFunction;
  onChange(value: string): void;
};

export const NewWellTextField = observer(function NewWellTextField({
  className,
  label,
  item,
  isDisabled,
  onBlur,
  onChange,
}: Props) {
  const localOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  const handleBlur = () => {
    onBlur?.();
  };

  return (
    <FormInput
      value={item.value}
      label={label}
      className={className}
      isError={!!item.errorText}
      errorText={item.errorText}
      placeholder={item.placeholder}
      isDisabled={isDisabled}
      onChange={localOnChange}
      onFocus={item.clearError}
      onBlur={handleBlur}
    />
  );
});
